import { RosterContent } from '@softapps/pms/roster-core';
import { EventTypeEnum } from '../types/event-type-enum';

//TODO: This function is a temporary solution to determine the event type based on the available data.
//TODO: It should be replaced with a more robust solution in the future, such as including the event type in the API response.

/** * Determines the event type based on the available data in the event object.
 * @param event The roster event for which the type should be determined.
 * @returns The determined event type as an EventTypeEnum value.
 */
export const getEventType = (event: RosterContent) => {
  if (event?.title === 'Urlaub' || event?.title === 'Zeitausgleich') {
    return EventTypeEnum.ABSENCE;
  }
  if (
    event.original?.['additionalData']?.type === 'APPOINTMENT' ||
    event['additionalData']?.type === 'APPOINTMENT'
  ) {
    return EventTypeEnum.APPOINTMENT;
  }
  if (
    event.original?.['additionalData']?.additionaldetail?.[0]?.tabname === 'TICKET' ||
    event['additionalData']?.additionaldetail?.[0]?.tabname === 'TICKET'
  ) {
    return EventTypeEnum.TICKET;
  }
  if (
    event.original?.['additionalData']?.additionaldetail?.[0]?.tabname === 'OBJECT' ||
    event['additionalData']?.additionaldetail?.[0]?.tabname === 'OBJECT'
  ) {
    return EventTypeEnum.OBJECT;
  }
  if (
    event.original?.['additionalData']?.additionaldetail?.length > 0 ||
    event.original?.['additionalData']?.type === 'PLAN' ||
    event['additionalData']?.type === 'PLAN'
  ) {
    return EventTypeEnum.PLAN;
  }
  return EventTypeEnum.NONE;
};
